import { Skeleton } from '@vtex/shoreline'
import { t } from 'i18next'

import { Button } from '~/components/Buttons'
import { useSidePanel } from '~/hooks/useSidePanel'

import RejectionReasonModal from '../RejectionReasonModal'

import { Pill } from './styles'

/**
 * Badge de status de aprovação de um subpublisher no fluxo de aprovação de
 * uma campanha. Quando o status é `rejected`, exibe também o botão "Saiba
 * mais" que abre um painel lateral com o motivo da rejeição.
 */
const SubpublisherApprovalBadge = ({
  status,
  reason,
  publisherName,
  contextName,
  publisherLogo
}: SubpublisherApprovalBadgeProps) => {
  const { addSidePanel } = useSidePanel()

  if (!status) {
    return (
      <div
        className="d-flex flex-nowrap flex-shrink-0 align-items-center justify-content-end"
        aria-busy="true"
        aria-label={t('rm:campaign.subpublishers.approvalStatus.loading')}
      >
        <Skeleton
          data-testid="approval-status-skeleton"
          width="9.5rem"
          height="1.75rem"
        />
      </div>
    )
  }

  const handleOpenReasonPanel = () => {
    addSidePanel({
      title: t('rm:campaign.subpublishers.approvalStatus.reason.modal.title'),
      type: 'content',
      size: 'fluid',
      content: (
        <RejectionReasonModal
          publisherName={contextName || publisherName}
          publisherLogo={publisherLogo}
          reason={reason}
        />
      )
    })
  }

  const reasonButton = status === 'rejected' && (
    <Button
      text={t('rm:campaign.subpublishers.approvalStatus.reason.cta')}
      template="tertiary"
      size="xsmall"
      customWidth="auto"
      className="text-nowrap flex-shrink-0"
      onClick={handleOpenReasonPanel}
    />
  )

  const statusPill = (
    <Pill status={status}>
      {t(`rm:campaign.subpublishers.approvalStatus.${status}`)}
    </Pill>
  )

  return (
    <div className="d-flex flex-nowrap flex-shrink-0 align-items-center justify-content-end gap-2">
      {reasonButton}
      {statusPill}
    </div>
  )
}

export default SubpublisherApprovalBadge
